import { createFileRoute, Link } from '@tanstack/react-router'
import { CalendarCheck, DollarSign, FileText, Receipt, Target, User } from 'lucide-react'
import { Card, CardContent } from '@/components/ui/card'

export const Route = createFileRoute('/hr/me/')({
  component: MeOverview,
})

const TILES = [
  { to: '/hr/me/profile', icon: User, title: 'Profile', desc: 'Your details' },
  { to: '/hr/me/attendance', icon: CalendarCheck, title: 'Attendance', desc: 'Your records' },
  { to: '/hr/me/leave', icon: FileText, title: 'Leave', desc: 'Your requests + balance' },
  { to: '/hr/me/payslips', icon: DollarSign, title: 'Payslips', desc: 'Your pay history' },
  { to: '/hr/me/expense-claims', icon: Receipt, title: 'Expenses', desc: 'Your submitted claims' },
  { to: '/hr/me/performance', icon: Target, title: 'Performance', desc: 'Your reviews' },
]

function MeOverview() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {TILES.map((t) => (
        <Link key={t.to} to={t.to}>
          <Card className="hover:bg-muted/30 transition-colors cursor-pointer">
            <CardContent className="p-4 flex items-center gap-3">
              <t.icon className="h-8 w-8 text-muted-foreground" />
              <div>
                <h3 className="font-semibold">{t.title}</h3>
                <p className="text-sm text-muted-foreground">{t.desc}</p>
              </div>
            </CardContent>
          </Card>
        </Link>
      ))}
    </div>
  )
}
